import React from 'react';
import {Container, Row, Col} from "react-bootstrap";
import {Link} from 'gatsby';

function Harness(props) {
    return (
        <section className="tekrevol_light_bg p-100">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
                        <div className="example" data-text="ORACLE Benefits">
                            <h2>Oracle Consulting Services To Help You Streamline Core Business Operations</h2>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="offset-lg-1">
                        <p>TekRevol’s Oracle consulting services are designed to help enterprises build failproof network infrastructure, create impregnable cloud database networks, and unlock scalability potential for unparalleled business optimization.</p>

                        <Link to="/contact"
                              className="border_btn" aria-label="TekRevol Contact">Let's Connect!</Link>
                    </Col>
                </Row>
            </Container>
        </section>
    );
}

export default Harness;